import {
    apiRequest,
    undanganpelantikanUpdate
} from "../../../../../services/adapters/kepegawaian/undanganPelantikanService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", undanganpelantikanUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository